import { render, staticRenderFns } from "./parkInfo.vue?vue&type=template&id=06d8046b&scoped=true"
import script from "./parkInfo.vue?vue&type=script&lang=js"
export * from "./parkInfo.vue?vue&type=script&lang=js"
import style0 from "./parkInfo.vue?vue&type=style&index=0&id=06d8046b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d8046b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06d8046b')) {
      api.createRecord('06d8046b', component.options)
    } else {
      api.reload('06d8046b', component.options)
    }
    module.hot.accept("./parkInfo.vue?vue&type=template&id=06d8046b&scoped=true", function () {
      api.rerender('06d8046b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parkCustomer/page/parkInfo.vue"
export default component.exports